import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M38 18.968q0-5.006-.189-8.136a7 7 0 0 0-6.363-6.55Q28.297 4 24 4q-4.301 0-7.454.282a7 7 0 0 0-6.363 6.566Q10 13.998 10 19.065q0 11.055.867 25.775a2 2 0 0 0 3.411 1.296l8.163-8.163c.612-.611.857-.777 1.18-.876q.38-.114.757 0c.324.099.57.265 1.181.876l8.16 8.16a2 2 0 0 0 3.41-1.3Q38 29.722 38 18.969m-2.185-8.016Q36 14.017 36 18.968q0 10.69-.867 25.75l-8.16-8.159c-.825-.825-1.333-1.17-2.015-1.375a3.27 3.27 0 0 0-1.916 0c-.682.206-1.19.55-2.015 1.375l-8.163 8.163Q12 30.058 12 19.065q0-5.017.18-8.1a5 5 0 0 1 4.545-4.69Q19.78 6 24 6q4.215 0 7.27.274a5 5 0 0 1 4.545 4.678",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "mask",
    {
      id: "Bookmark-Outlined_svg__a",
      width: 28,
      height: 43,
      x: 10,
      y: 4,
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M38 18.968q0-5.006-.189-8.136a7 7 0 0 0-6.363-6.55Q28.297 4 24 4q-4.301 0-7.454.282a7 7 0 0 0-6.363 6.566Q10 13.998 10 19.065q0 11.055.867 25.775a2 2 0 0 0 3.411 1.296l8.163-8.163c.612-.611.857-.777 1.18-.876q.38-.114.757 0c.324.099.57.265 1.181.876l8.16 8.16a2 2 0 0 0 3.41-1.3Q38 29.722 38 18.969m-2.185-8.016Q36 14.017 36 18.968q0 10.69-.867 25.75l-8.16-8.159c-.825-.825-1.333-1.17-2.015-1.375a3.27 3.27 0 0 0-1.916 0c-.682.206-1.19.55-2.015 1.375l-8.163 8.163Q12 30.058 12 19.065q0-5.017.18-8.1a5 5 0 0 1 4.545-4.69Q19.78 6 24 6q4.215 0 7.27.274a5 5 0 0 1 4.545 4.678",
        clipRule: "evenodd"
      }
    )
  ),
  /* @__PURE__ */ React.createElement("g", { mask: "url(#Bookmark-Outlined_svg__a)" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 0h48v48H0z" }))
);
var SvgBookmarkOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var BookmarkOutlined_default = SvgBookmarkOutlined;

export { BookmarkOutlined_default as default };
